import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      token: '',
      refreshToken: "",
      tokenUpdateTime: "",
      userInfo: {},
      username: '',
      company_no: '',
      id: '',
      pageTopData: [],
      userRoles: ""
    },
    updateParaval: ""
  },
  mutations: {
    updateUserRoles(state, change) {
      state.userRoles = change || '';
      localStorage.setItem('userRoles', change);
    },
    updateToken(state, change) {
      state.token = change || '';
      localStorage.setItem('fire-token', change);
    },
    updateRefreshToken(state, change) {
      state.refreshToken = change.refreshToken || '';
      state.tokenUpdateTime = change.updateTime || '';
      localStorage.setItem('refreshToken', change.refreshToken);
      localStorage.setItem('tokenUpdateTime', change.updateTime);
    },
    updateUserInfo(state, change) {
      state.userInfo = change || {};
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    updateUserAuthority(state, change) {
      state.userAuthority = change || '';
      localStorage.setItem('userAuthority', JSON.stringify(change));
    },
    updatepageTopData(state, change) {
      state.pageTopData = change || [];
    },
    updateParaval(state, change) {
      state.updateParaval = change || "";
      localStorage.setItem('updateParaval', state.updateParaval)
    }
  },
  actions: {

  }
})
